import makeStateFilter from '../../../make-state-filter';

import { stateFilter as parentStateFilter } from '../batches.reducer.metadata';

const namespace = 'createWithoutFulfillmentPlans';
const stateFilter = makeStateFilter(parentStateFilter, namespace);

export { namespace, stateFilter };
